
import React, { useState } from "react";
import { Link } from "react-router-dom";
import SRList from "../component/List";
import AkkhorLayout from "../layout/akkhor";
import SearchBoxModal from "../component/SearchBoxModal";

export default function DanhSachDeThi() {
    const [params, setParam] = useState('');
    const [title, setTitle] = useState('');
    const [loai, setLoai] = useState('');
    const [courseId, setCourseId] = useState('');
    const [filterShow, setFilterShow] = useState(false);

    const handleSubmit = (e) => {
        e.preventDefault();
        let _param = '';
        if (title !== '') _param += "&title=" + title;
        if (loai !== '') _param += "&loai=" + loai;
        if (courseId !== '') _param += "&course_id=" + courseId;
        setParam(_param);
    };

    let columns = [
        { name: "id", label: "ID", options: { filter: false, sort: true } },
        { name: "title", label: "Tiêu đề" },
        {
            name: "loai", label: "Loại",
            options: { customBodyRender: (v) => v === 'baitap' ? 'Bài tập về nhà' : 'Bài kiểm tra' }
        },
        { name: "course_title", label: "Khóa học" },
        { name: "baigiang_title", label: "Bài giảng" },
        { name: "so_cau", label: "Số câu" },
        { name: "tong_diem", label: "Tổng điểm" },
        { name: "author_name", label: "Người tạo" },
        { name: "datecreate", label: "Ngày tạo" },
    ];

    return (<AkkhorLayout idrole="learninghub_dethi">
        <div className="breadcrumbs-area">
            <ul>
                <li><Link to="/">Trang chủ</Link></li>
                <li>Bài kiểm tra / Bài tập</li>
            </ul>
        </div>
        <div className="card card-filter mb-3">
            <div className="card-header">
                <div className="d-flex" onClick={() => setFilterShow(!filterShow)}>
                    <div className="mr-auto"><h3 className="title">Tìm kiếm</h3></div>
                    <button className="btn btn-sm btn-defaul"><span className={!filterShow ? "fas fa-angle-down" : "fas fa-angle-up"}></span></button>
                </div>
            </div>
            <div className={filterShow ? "card-body" : 'hidden-filter'}>
                <form className="new-added-form" method="get">
                    <div className="row">
                        <div className="col-sm-3 col-12 form-group">
                            <label>Tiêu đề</label>
                            <input type="text" placeholder="Tiêu đề" value={title} onChange={(e) => setTitle(e.target.value)} className="form-control height32" autoComplete="off" />
                        </div>
                        <div className="col-sm-3 col-12 form-group">
                            <label>Loại</label>
                            <select className="form-select height32" value={loai} onChange={(e) => setLoai(e.target.value)}>
                                <option value="">Tất cả</option>
                                <option value="kiemtra">Bài kiểm tra</option>
                                <option value="baitap">Bài tập về nhà</option>
                            </select>
                        </div>
                        <div className="col-sm-3 col-12 form-group">
                            <label>Khóa học</label>
                            <SearchBoxModal apiname={"learninghub_khoahoc"} alldata={"?status=1"} placeholder="Chọn khóa học" colvalue={'id'} colname={'title'} name='course_id'
                                onChange={(e) => setCourseId(e)}></SearchBoxModal>
                        </div>
                        <div className="col-12">
                            <button type="submit" onClick={handleSubmit} className="btn-fill-sm btn-gradient-yellow btn-hover-bluedark">Lọc</button>
                        </div>
                    </div>
                </form>
            </div>
        </div>
        <SRList name="learninghub_dethi" linkaction="learninghub_dethi" idrole="learninghub_dethi" params={params} defaultLimit={50} serverSide={true} columns={columns}></SRList>
    </AkkhorLayout>);
}
